module.exports = __webpack_public_path__ + "static/a-man-on-the-beach-staring-at-the-ocean.193ff9a1.webp";